var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser ||
    _vm.$userInfo.isCustomerAdministrator ||
    _vm.$userInfo.isSystemAdministrator
      ? _c("div", [
          _c("div", { staticClass: "tile is-parent pl-1" }, [
            _c("article", { staticClass: "tile is-child box" }, [
              _c(
                "div",
                { staticClass: "columns is-flex is-align-items-center" },
                [
                  _vm._m(0),
                  !_vm.hasError &&
                  _vm.showSavingStatus &&
                  !_vm.toastNotificationEnabled
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "column is-flex is-justify-content-flex-end is-align-items-center",
                        },
                        [
                          _vm.saving
                            ? _c("span", {
                                staticClass: "button is-loading is-white",
                                staticStyle: { height: "27px" },
                              })
                            : _c(
                                "span",
                                { staticClass: "text has-text-success" },
                                [
                                  _c("span", { staticClass: "mso mso-18px" }, [
                                    _vm._v("check_circle"),
                                  ]),
                                ]
                              ),
                          _c(
                            "span",
                            {
                              staticClass: "is-size-6",
                              class: _vm.saving
                                ? "has-text-warning"
                                : "has-text-success",
                            },
                            [_vm._v(_vm._s(_vm.savingStatus))]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _c("div", { staticClass: "field columns" }, [
                _c("div", { staticClass: "column is-half" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Name")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.companyDetails.name,
                          expression: "companyDetails.name",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        disabled: !_vm.$userInfo.isSystemAccount,
                      },
                      domProps: { value: _vm.companyDetails.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.companyDetails,
                            "name",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    !_vm.$v.companyDetails.name.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Name is required "),
                        ])
                      : _vm._e(),
                    !_vm.$v.companyDetails.name.companynameUnique
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Company name is already in use. "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "column is-half" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.companyDetails.abn,
                          expression: "companyDetails.abn",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        disabled: !_vm.$userInfo.isSystemAccount,
                      },
                      domProps: { value: _vm.companyDetails.abn },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.companyDetails,
                            "abn",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    !_vm.$v.companyDetails.abn.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("ABN is required "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "field columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-half pb-0" },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Customer Since"),
                    ]),
                    !_vm.$userInfo.isSystemAccount
                      ? _c("input", {
                          staticClass: "input",
                          attrs: { disabled: "" },
                          domProps: {
                            value: _vm.$filters.formatDateLocale(
                              _vm.innerCustomerSince,
                              _vm.$userInfo.locale
                            ),
                          },
                        })
                      : _c("v-date-picker", {
                          staticClass: "is-fullwidth",
                          attrs: {
                            "is-dark": _vm.$theme.isDark,
                            masks: _vm.formats,
                            attributes: _vm.attrs,
                            locale: _vm.$userInfo.locale,
                            "max-date": _vm.today,
                            timezone: _vm.$filters.getIanaTimezone(),
                          },
                          on: { input: _vm.customerSinceInputEvent },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ inputValue, inputEvents }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "field has-addons" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "control is-expanded has-icons-left",
                                          },
                                          [
                                            _c(
                                              "input",
                                              _vm._g(
                                                {
                                                  staticClass: "input",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "Customer Since",
                                                  },
                                                  domProps: {
                                                    value: inputValue,
                                                  },
                                                },
                                                inputEvents
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon is-small is-left",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "mso mso-18px",
                                                  },
                                                  [_vm._v("calendar_month")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2470198337
                          ),
                          model: {
                            value: _vm.innerCustomerSince,
                            callback: function ($$v) {
                              _vm.innerCustomerSince = $$v
                            },
                            expression: "innerCustomerSince",
                          },
                        }),
                  ],
                  1
                ),
                _c("div", { staticClass: "column is-half pb-0" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Registered ID"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.companyDetails.companyRegisteredId,
                          expression: "companyDetails.companyRegisteredId",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "number",
                        maxlength: "6",
                        disabled: !_vm.$userInfo.isSystemAccount,
                      },
                      domProps: {
                        value: _vm.companyDetails.companyRegisteredId,
                      },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companyDetails,
                              "companyRegisteredId",
                              $event.target.value
                            )
                          },
                          _vm.onRegisteredIdInput,
                        ],
                        keydown: _vm.preventNonDigit,
                      },
                    }),
                    !_vm.$v.companyDetails.companyRegisteredId.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Registered ID is required "),
                        ])
                      : _vm._e(),
                    !_vm.$v.companyDetails.companyRegisteredId
                      .companyRegisteredIdUnique
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Registered ID is already in use. "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              !_vm.$userInfo.isSupportUser &&
              _vm.$userInfo.isSystemAdministrator &&
              !_vm.companyDetails.isHq &&
              !_vm.isHQ
                ? _c("div", { staticClass: "field columns" }, [
                    _c("div", { staticClass: "column is-half pb-0" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("HQ Company"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("bulma-autocomplete", {
                            attrs: {
                              placeholder: "HQ Company",
                              data: _vm.hqCompanyNoOptions,
                              field: "companyLoginId",
                              loading: _vm.hqCompanyNoLoading,
                            },
                            on: {
                              typing: _vm.onHqCompanyNoTyping,
                              select: function ($event) {
                                return _vm.onHqSelected($event)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            `${props.option.companyLoginId}`
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              278785023
                            ),
                            model: {
                              value: _vm.selectedHqCompanyNo,
                              callback: function ($$v) {
                                _vm.selectedHqCompanyNo = $$v
                              },
                              expression: "selectedHqCompanyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "column is-half pb-0" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Parent Company Name"),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.companyDetails.parentCompanyName,
                              expression: "companyDetails.parentCompanyName",
                            },
                          ],
                          staticClass: "input",
                          attrs: { type: "text", disabled: true },
                          domProps: {
                            value: _vm.companyDetails.parentCompanyName,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.companyDetails,
                                "parentCompanyName",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("hr"),
              _c("div", { staticClass: "field columns" }, [
                _c("div", { staticClass: "column is-half pt-0 mt-3" }, [
                  _c("div", { staticClass: "mb-5" }, [
                    _c("label", { staticClass: "label" }, [_vm._v("Country")]),
                    _c(
                      "div",
                      {
                        staticClass: "control tooltip",
                        attrs: { "data-tooltip": "Country of Default Address" },
                      },
                      [
                        _c("div", { staticClass: "select is-fullwidth" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.companyDetails.countryCode,
                                  expression: "companyDetails.countryCode",
                                },
                              ],
                              attrs: {
                                disabled:
                                  !_vm.$userInfo.isSupportUser &&
                                  !_vm.$userInfo.isSystemAdministrator,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.companyDetails,
                                    "countryCode",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "null", disabled: "" } },
                                [_vm._v("Select")]
                              ),
                              _vm._l(_vm.countries, function (country) {
                                return _c(
                                  "option",
                                  {
                                    key: country.countryCode,
                                    domProps: { value: country.countryCode },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(country.countryDesc) + " "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "mb-5" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Time Zone"),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select is-fullwidth" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.companyDetails.timezone,
                                expression: "companyDetails.timezone",
                              },
                            ],
                            attrs: {
                              disabled:
                                !_vm.companyDetails.countryCode ||
                                (!_vm.$userInfo.isSupportUser &&
                                  !_vm.$userInfo.isSystemAdministrator),
                            },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.companyDetails,
                                  "timezone",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(_vm.timezones, function (timezone) {
                              return _c(
                                "option",
                                {
                                  key: timezone.Id,
                                  domProps: { value: timezone.DisplayName },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(timezone.DisplayName) + " "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "mb-5" }, [
                    _c("label", { staticClass: "label" }, [_vm._v("Locale")]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select is-fullwidth" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.companyDetails.locale,
                                expression: "companyDetails.locale",
                              },
                            ],
                            attrs: {
                              disabled:
                                !_vm.companyDetails.countryCode ||
                                (!_vm.$userInfo.isSupportUser &&
                                  !_vm.$userInfo.isSystemAdministrator),
                            },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.companyDetails,
                                  "locale",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(_vm.locales, function (locale, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: locale } },
                                [_vm._v(" " + _vm._s(locale) + " ")]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "is-divider-vertical p-0" }),
                _c("div", { staticClass: "column is-half pb-0" }, [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("company-asset-addresses", {
                        ref: "assetAddresses",
                        attrs: {
                          addresses: _vm.sortedAddresses,
                          "country-code": _vm.companyDetails.countryCode,
                        },
                        on: {
                          removeAddress: _vm.removeAddress,
                          setDefault: _vm.setDefault,
                          addTmpAddress: _vm.addTmpAddress,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("hr"),
              _c("div", { staticClass: "field columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-half" },
                  [
                    _c("company-asset-phones", {
                      ref: "assetPhones",
                      attrs: { phones: _vm.sortedPhones },
                      on: {
                        removePhone: _vm.removePhone,
                        setDefault: _vm.setDefault,
                        addTmpPhone: _vm.addTmpPhone,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column is-half" },
                  [
                    _c("company-asset-emails", {
                      ref: "assetEmails",
                      attrs: { emails: _vm.sortedEmails },
                      on: {
                        removeEmail: _vm.removeEmail,
                        setDefault: _vm.setDefault,
                        addTmpEmail: _vm.addTmpEmail,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "field columns mb-2" }, [
                _c(
                  "div",
                  { staticClass: "column is-half" },
                  [
                    _vm.$userInfo.isSystemAccount ||
                    _vm.$userInfo.isSystemAdministrator
                      ? _c("company-contact", {
                          ref: "assetContacts",
                          attrs: {
                            contacts: _vm.companyDetails.contacts,
                            "company-id": _vm.companyDetails.companyId,
                          },
                          on: {
                            addContact: _vm.addContact,
                            removeContact: _vm.removeContact,
                            setDefault: _vm.setDefault,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm.$userInfo.isSystemAccount && !_vm.isNew
                ? _c("div", { staticClass: "field columns" }, [
                    _c("div", { staticClass: "column is-half pb-0" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Reset User Password"),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary tooltip",
                          attrs: { "data-tooltip": "Reset Password" },
                          on: { click: _vm.resetPassword },
                        },
                        [_c("span", [_vm._v("Reset Password")])]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.$userInfo.isSystemAccount
                ? _c("div", { staticClass: "is-divider" })
                : _vm._e(),
              _vm.$userInfo.isSystemAccount
                ? _c("div", { staticClass: "field" }, [
                    _c(
                      "div",
                      { staticClass: "buttons has-addons is-centered" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "button",
                            class: {
                              "is-success is-selected":
                                _vm.companyDetails.isActive,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleActive(true)
                              },
                            },
                          },
                          [_vm._m(1), _c("span", [_vm._v("Active")])]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "button",
                            class: {
                              "is-danger is-selected":
                                !_vm.companyDetails.isActive,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleActive(false)
                              },
                            },
                          },
                          [_vm._m(2), _c("span", [_vm._v("In-Active")])]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm.$userInfo.isSystemAdministrator && _vm.isNew && _vm.user
            ? _c("div", { staticClass: "tile is-parent pl-1" }, [
                _c("article", { staticClass: "tile is-child box" }, [
                  _vm._m(3),
                  _c("div", { staticClass: "field columns" }, [
                    _c("div", { staticClass: "column is-half" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("Email")]),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.email,
                              expression: "user.email",
                            },
                          ],
                          staticClass: "input",
                          attrs: { type: "text", autocomplete: "new-email" },
                          domProps: { value: _vm.user.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.user, "email", $event.target.value)
                            },
                          },
                        }),
                        !_vm.$v.user.email.required
                          ? _c("span", { staticClass: "help is-danger" }, [
                              _vm._v("Email is required "),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Username"),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.username,
                              expression: "user.username",
                            },
                          ],
                          staticClass: "input",
                          attrs: { type: "text", autocomplete: "new-username" },
                          domProps: { value: _vm.user.username },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.user,
                                "username",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        !_vm.$v.user.username.required
                          ? _c("span", { staticClass: "help is-danger" }, [
                              _vm._v("Username is required "),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "field columns" }, [
                    _c("div", { staticClass: "column is-half" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Password"),
                      ]),
                      _c("div", { staticClass: "field has-addons" }, [
                        _c("div", { staticClass: "control is-expanded" }, [
                          (_vm.showPassword ? "text" : "password") ===
                          "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user.password,
                                    expression: "user.password",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  autocomplete: "new-password",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.user.password)
                                    ? _vm._i(_vm.user.password, null) > -1
                                    : _vm.user.password,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.user.password,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.user,
                                            "password",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.user,
                                            "password",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.user, "password", $$c)
                                    }
                                  },
                                },
                              })
                            : (_vm.showPassword ? "text" : "password") ===
                              "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user.password,
                                    expression: "user.password",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  autocomplete: "new-password",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.user.password, null),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.user, "password", null)
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user.password,
                                    expression: "user.password",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  autocomplete: "new-password",
                                  type: _vm.showPassword ? "text" : "password",
                                },
                                domProps: { value: _vm.user.password },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.user,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                          !_vm.$v.user.password.required
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v("Password is required "),
                              ])
                            : _vm._e(),
                          !_vm.$v.user.password.validatePassword
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v(" " + _vm._s(_vm.passwordMessage) + " "),
                              ])
                            : _vm._e(),
                        ]),
                        _c("p", { staticClass: "control" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              on: {
                                click: function ($event) {
                                  _vm.showPassword = !_vm.showPassword
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "icon has-text-primary" },
                                [
                                  _c("span", { staticClass: "mso mso-24px" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showPassword
                                            ? "visibility"
                                            : "visibility_off"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-flex is-align-items-center" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Default Administrator")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }